import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3 whitespace-nowrap">
            Product Categories
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            All <span className="text-primary-500">Sugargoo Spreadsheet</span> Product Categories
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            Click any category to explore curated Sugargoo Spreadsheet finds on our main website. Updated regularly with the latest community discoveries.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat, idx) => (
            <a
              key={cat.seq}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-background-100 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl text-foreground-500 group-hover:text-primary-500 transition-colors`}></i>
              </div>
              <span className="text-xs md:text-sm font-semibold text-foreground-700 group-hover:text-primary-600 transition-colors text-center whitespace-nowrap leading-tight">
                {cat.name}
              </span>
              <div className="flex items-center gap-1 text-xs text-primary-400 opacity-0 group-hover:opacity-100 transition-opacity">
                <span>Browse</span>
                <i className="ri-arrow-right-up-line text-xs"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}